module.exports = __webpack_public_path__ + "img/northern-marianas-islands.6548ef7d.svg";